<template>
  <div class="rules">
    <!-- <h4 class="headtitle">{{$t('ContactUs')}}:</h4> -->
    <div v-html="contac.content">
      <!-- {{$t('Contact')}}：{{contac.contacts||''}}<br/>
      {{$t('Tel')}}：{{contac.telephone||''}}<br/>
      {{$t('Fax')}}：{{contac.fax||''}}<br/>
      QQ：{{contac.qq||''}}<br/>
      {{$t('Zipcoad')}}：{{contac.postalCode||''}}<br/>
      {{$t('Emailaddress')}}：{{contac.mailbox||''}}<br/>
      {{$t('Address')}}：{{contac.address||''}} -->
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      contac:{

      }
    }
  },
  created(){
    this.$getHttp("pc/tContactusInfo/findByIdContactusInfo",{
      id:1
    }).then((res) => {
      if (res.success) {
       
        this.contac = res.ContactusInfo;
// address: "北京市丰台区顺三条 21 号嘉业大厦二期 1 号楼 16 层"
// contacts: "组委会"
// createBy: "1"
// createDate: "2022-09-01"
// deleteFlag: "0"
// fax: "010-67660809"
// id: 1
// language: "1"
// mailbox: "xxxxxxxx@163.com"
// postalCode: "100079"
// qq: "xxxxxxx"
// telephone: "010-67662159-833/833"
// updateBy: "1"
// updateDate: "2022-09-01"
      } else {
        this.$message({
          message: res.msg,
        });
      }
    });
  },
  methods:{

  }
}
</script>

<style lang="less">
  .rules{
    text-align: left;
    .headtitle{
      position: relative;
      font-size: 26px;
      font-family: PingFang SC-Regular, PingFang SC;
      color: #333333;
      font-weight: 500;
      padding-left: 20px;
      margin-left: 5px;
      margin-top: 6px;
      margin-bottom: 25px;
      // &:before{
      //   position: absolute;
      //   content: '';
      //   left: 0;
      //   top:50%;
      //   transform: translateY(-50%);
      //   width: 4px;
      //   height: 24px;
      //   background: #6F73F4;
      //   border-radius: 2px 2px 2px 2px;
      // }
    }
    // .boxs{
    //   font-size: 22px;
    //   font-family: PingFang SC-Regular, PingFang SC;
    //   font-weight: 400;
    //   color: #333333;
    //   line-height: 50px;
    //   margin-bottom: 60px;
    // }
  }
</style>